import { PaymentStatus } from '@repo/common';
import { Button } from '@repo/shadcn';
import { Loader2Icon } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { IwForm } from '@components/form';

import {
    AddPaymentFormSchema,
    INITIAL_VALUE,
    TAddPaymentForm,
} from '@/modules/cart/add-payment-form.schema.ts';
import { AddPayment } from '@/modules/cart/add-payment.component.tsx';
import { useOrderDetailsContext } from '@/modules/sales/order-details/context.tsx';

const AddOrderPaymentComponent = () => {
    const { data, isMultiPayLoading } = useOrderDetailsContext();
    const { watch } = useFormContext<TAddPaymentForm>();

    const payments = watch('payments');

    const formTotal =
        payments?.reduce(
            (total, payment) => total + (payment.amount ?? 0),
            0,
        ) ?? 0;

    const isPaid = data?.data?.payment?.status === PaymentStatus.PAID;
    const totalPrice = data?.data?.payment?.total_price ?? 0;
    const totalPaid = data?.data?.payment?.total_paid ?? 0;

    const dueAmount = totalPrice - totalPaid;

    const isButtonDisabled = isMultiPayLoading || isPaid || formTotal === 0;

    if (isPaid) {
        return null;
    }

    return (
        <AddPayment totalPrice={dueAmount}>
            <div className={'flex justify-end'}>
                <Button
                    disabled={isButtonDisabled}
                    className={'flex items-center justify-center'}
                >
                    {isMultiPayLoading ? (
                        <>
                            <Loader2Icon />
                            Loading...
                        </>
                    ) : (
                        'Confirm Payment'
                    )}
                </Button>
            </div>
        </AddPayment>
    );
};

export const AddOrderPayment = () => {
    const { handleMakePayment } = useOrderDetailsContext();
    return (
        <IwForm
            schema={AddPaymentFormSchema}
            initialValues={INITIAL_VALUE}
            onSubmit={(data) => {
                handleMakePayment(data as TAddPaymentForm);
            }}
        >
            <AddOrderPaymentComponent />
        </IwForm>
    );
};

AddOrderPayment.displayName = 'AddOrderPayment';
